import React, { useMemo, useState } from "react";
import { BlueBirdTheme, Button } from "@kitbird/core";
import { ColumnI } from "../../../../../components/Table/TableProps";
import { ReactComponent as EditIcon } from "../../../../../assets/icons/edit.svg";
import { ReactComponent as TrashIcon } from "../../../../../assets/icons/trash.svg";
import Table from "../../../../../components/Table";
import mockBank from "./mockData";

interface BankTableProps {
  setEditValue: React.Dispatch<React.SetStateAction<unknown>>;
  showModal: () => void;
  showDeleteModal: () => void;
}

const { primary, danger } = BlueBirdTheme.colors;

const BankTable = ({ setEditValue, showModal, showDeleteModal }: BankTableProps) => {
  const [sort, setSort] = useState<any>({
    sortBy: "",
    sortType: "DEFAULT",
  });

  const renderActions = (item: any, row: Record<string, any>) => (
    <div style={{ display: "flex", gap: 8 }}>
      <Button
        style={{ padding: "8px 10px" }}
        backgroundColor={primary[300]}
        onClick={() => {
          setEditValue(row);
          showModal();
        }}
      >
        <EditIcon width={16} height={16} />
      </Button>
      <Button
        style={{ padding: "8px 10px" }}
        backgroundColor={danger[400]}
        onClick={() => showDeleteModal()}
      >
        <TrashIcon width={16} height={16} />
      </Button>
    </div>
  );

  const columns: ColumnI[] = useMemo(() => [
    {
      title: "Nama bank",
      dataIndex: "bank_code",
      key: "bank_code",
      width: "200px",
      sort: true,
    },
    {
      title: "Deskripsi",
      dataIndex: "bank_desc",
      key: "bank_desc",
      width: "calc(100% - 350px)",
    },
    {
      title: "Action",
      dataIndex: "id",
      key: "id",
      width: "100px",
      render: renderActions,
    },
  ], []);

  return (
    <Table
      withNumber
      columns={columns}
      dataSource={mockBank}
      sortConfig={{
        sortType: sort.sortType,
        sortBy: sort.sortBy,
        onSort: (name, type) => setSort({ sortBy: name, sortType: type }),
      }}
    />
  );
};

export default BankTable;
